module.exports = __webpack_public_path__ + "fonts/Averta-Regular.5e207a9.woff";